'use client';
import Script from 'next/script';
import type { PropsWithChildren } from 'react';

import { HotjarScript } from '@/components/3rdParty/HotjarScript';

export const ExternalMainScripts = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <HotjarScript />
    <Script src="/pixels/customer-io.js" strategy="afterInteractive" />
  </>
);
